import { useMemo } from 'react';
import dayjs from 'dayjs';
import { useConfigs } from 'shared/src/queries';

/**
 * 오늘 날짜가 "오늘출발" 영업일인지 판별.
 * - 토요일/일요일은 영업일 아님
 * - delivery_holidays에 포함된 날짜도 영업일 아님
 */
export const useIsTodayDeliveryOperatingDay = () => {
  const { data: configs } = useConfigs();

  return useMemo(() => {
    const today = dayjs();
    const day = today.day();
    if (day === 0 || day === 6) return false;

    const todayKey = today.format('YYYY-MM-DD');
    return !(configs?.delivery_holidays ?? []).includes(todayKey);
  }, [configs?.delivery_holidays]);
};
